import Player from '@vimeo/player';
import { event } from 'jquery';

export default () => {
    const vimeoPlayers = document.querySelectorAll('.vimeo-container');

    if (vimeoPlayers.length > 0) {
    // Loop through each video container and create a Vimeo player
    vimeoPlayers.forEach((element) => {
          const player = new Player(element);
          player.getVideoTitle().then(title => {
            player.on('play', () => {
              dataLayer.push({
                event: 'vimeo_play',
                vimeoTitle: title,
              });
            })
            player.on('pause', () => {
              dataLayer.push({
                event: 'vimeo_pause',
                vimeoTitle: title,
              });
            })
            player.on('ended', () => {
              dataLayer.push({
                event: 'vimeo_ended',
                vimeoTitle: title,
              });
            })
            // Create Sets outside the event handler to track logged events
            const loggedTimes = new Set();
            const loggedPercentages = new Set();
            
            player.on('timeupdate', (data) => {
                const currentTime = Math.floor(data.seconds);
                const percentage = Math.floor((currentTime / data.duration) * 100);
                
                // Log time intervals (every 10 seconds) only once
                if (currentTime % 10 === 0 && currentTime > 0 && !loggedTimes.has(currentTime)) {
                    loggedTimes.add(currentTime);
                    dataLayer.push({
                      event: 'vimeo_timeupdate',
                      vimeoTitle: title,
                      vimeoTime: currentTime.toString(),
                    });
                }
                
                // Log percentage in increments of 10
                const roundedPercentage = Math.floor(percentage / 10) * 10;
                if (!loggedPercentages.has(roundedPercentage)) {
                    loggedPercentages.add(roundedPercentage);
                    if (roundedPercentage === 0) {
                      dataLayer.push({
                        event: 'vimeo_start',
                        vimeoTitle: title,
                      });
                    } else {
                      dataLayer.push({
                        event: 'vimeo_percentage',
                        vimeoTitle: title,
                        vimeoPercentage: roundedPercentage.toString(),
                      });
                    }
                }
            });
          })
      });
    }
}

